import React from 'react';
import { DotLoader } from 'react-spinners';

const Loader = ({ isDarkMode }) => {
  const backgroundColor = isDarkMode ? 'bg-[#0F172A]' : 'bg-[#DADDFB]';
  const spinnerColor = isDarkMode ? '#A5B4FC' : '#4F46E5';

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center ${backgroundColor}`}
    >
      <DotLoader size={80} color={spinnerColor} speedMultiplier={1.2} />
    </div>
  );
};

export default Loader;
